import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { TicketsCounter } from './ticketsCounter.component';
import { selectExperienceAgeLimits, selectExperienceTicketTypes } from '../../../../../modules/experience';
import { selectBookingTickets, BookingActions } from '../../../../../modules/booking';

const mapStateToProps = createStructuredSelector({
  ticketTypes: selectExperienceTicketTypes,
  bookingTickets: selectBookingTickets,
  ageLimits: selectExperienceAgeLimits,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateBookingTicketCount: BookingActions.setTicketsCount,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(TicketsCounter);
